<template>
  <div class="container">
    <div class="row justify-content-md-center align-items-center">
      <div class="col-lg-4">
        <form class="login">
          <div class="form-group">
            <h3>Login</h3>
            <input v-model="email" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email">
          </div>
          <div class="form-group">
            <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
          </div>
          <button v-on:click.prevent="login" type="submit" class="btn btn-primary">Login</button>
          <router-link to="/sign-up">No Account? </router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// import { store } from '../store/store.js'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/customize')
      }
    }
  },
  methods: {
    login (state, user) {
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue